import userProfile from "../../components/UserProfile/state/userprofile.slice"

export const appReducer = {
  userProfile
}
